import { types } from '../constants';

export const openChangePasswordDialogDispatch = (open) => ({
  type: types.OPEN_CHANGE_PASSWORD_DIALOG,
  open
});

export const openDeleteUserDialogDispatch = (open) => ({
  type: types.OPEN_DELETE_USER_DIALOG,
  open
});

export const changePasswordDispatch = (userEmail) => ({
  type: types.SEND_CHANGE_PASSWORD_REQUEST,
  userEmail
});

export const setLoggedInUserDispatch = (user) => ({
  type: types.SET_LOGGED_IN_USER,
  user
});

export const openCreateUserDialogDispatch = (open) => ({
  type: types.OPEN_CREATE_USER_DIALOG,
  open
});

export const openEditUserDialogDispatch = (open) => ({
  type: types.OPEN_EDIT_USER_DIALOG,
  open
});

export const handleUserInputChangeDispatch = (value, inputFieldName) => ({
  type: types.INPUT_CHANGE_CREATE_USER_FORM,
  value,
  inputFieldName
});

export const submitUserDispatch = (user, mode) => ({
  type: types.SUBMIT_USER,
  user,
  mode
});

export const searchTermChangeForAllUsers = (searchTerm) => ({
  type: types.CHANGE_SEARCH_TERM_ALL_USERS,
  searchTerm
});

export const fetchAllUsersDispatch = () => ({
  type: types.FETCH_ALL_USERS
});

export const userEditClickDispatch = (user) => ({
  type: types.EDIT_USER,
  user
});

export const checkBranchAccessForUserDispatch = (payload) => ({
  type: types.CHECK_BRANCH_ACCESS_FOR_USER,
  payload
});
